import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ForbiddenErrorService } from './errors/forbidden.service';
import { ConflictErrorService } from './errors/conflict.service';
import { NotAuthorizedErrorService } from './errors/notAuthorized.service';
import { NotFoundErrorService } from './errors/notFound.service';
import { BadRequestErrorService } from './errors/badRequest.service';
import { IError } from '../models/error.model';
/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private forbidenService: ForbiddenErrorService,
    private conflictService: ConflictErrorService,
    private notAuthorizedService: NotAuthorizedErrorService,
    private notFoundService: NotFoundErrorService,
    private badRequestService: BadRequestErrorService
  ) { }

  whichError(error: HttpErrorResponse): IError {
    let newError = {
      code: error.status,
      message: 'An unknown error occurred.'
    } as IError;
    
    if (error.error instanceof ErrorEvent) {
      return newError;
    } else {
      newError.errorCode = error.error.errorCode;
      

      switch (error.error.code) {
        case 400: 
          newError.message = this.badRequestService.badRequestError(error.error.errorCode);
          break;
        case 401:
          newError.message = this.notAuthorizedService.notAuthorizedError(error.error.errorCode);
          break;
        case 403:
          newError.message = this.forbidenService.forbiddenError(error.error.errorCode);
          break;
        case 404:
          newError.message = this.notFoundService.notFoundError(error.error.errorCode);
          break;
        case 409:
          newError.message = this.conflictService.conflictError(error.error.errorCode);
          break;
        case 500:
          newError.message = 'Internal Server Error';
          break;
      }
      return newError;
    }
  }
}

